/* eslint no-console: 0 */

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import BootstrapVue from 'bootstrap-vue'
import jQuery from 'jquery'
import Vue from 'vue'
import Vuex from 'vuex'

import AppMobile from './components/stencilease-form-mobile.vue'
import App from './components/stencilease-form.vue'
import store from './components/store'

Vue.use(Vuex)
Vue.use(BootstrapVue)

Vue.component('jQuery', jQuery)

document.addEventListener('DOMContentLoaded', () => {
  new Vue({
    store,
    render : function(createElement) {
      var w = window, d = document, e = d.documentElement,
          g = d.getElementsByTagName('body')[0],
          x = w.innerWidth || e.clientWidth || g.clientWidth;

      if (x < 1024) {
        jQuery('#stencilform-previews').css('top', 'unset');
        return createElement(AppMobile);
      } else {
        return createElement(App);
      }
    },
    created : function() {
      this.$store.dispatch('product/SET_PRODUCTS',
                           Stencilease.settings.products);
      this.$store.dispatch('product/SET_MATERIALS',
                           Stencilease.settings.materials);
      this.$store.dispatch('product/SET_FONTS', Stencilease.settings.fonts);
      this.$store.dispatch('product/SET_FONT_SIZES',
                           Stencilease.settings.font_sizes);
      this.$store.dispatch('product/SET_BORDER_RULES',
                           Stencilease.settings.border_rules);
      this.$store.dispatch('product/SET_DISCOUNT_SCHEDULE',
                           Stencilease.settings.discount_schedule);
      this.$store.dispatch('product/SET_DISCOUNT_TEXTS',
                           Stencilease.settings.discount_texts);

      if (Stencilease.settings.default_font) {
        this.$store.dispatch('product/SET_TEXT_FONT',
                             Stencilease.settings.default_font);
      }

      if (Stencilease.settings.default_font_height) {
        this.$store.dispatch('product/SET_HEIGHT',
                             Stencilease.settings.default_font_height);
      }
    }
  }).$mount('#stencilease-form');
})
